import React, { ReactNode } from 'react'
import { StyledErrorBoxContainer } from './error-box.style'

interface errorBoxProps {
    children: ReactNode
    dataTestid?: string
}

export const ErrorBox = ({ children, dataTestid = '' }: errorBoxProps) => {
    return (
        <StyledErrorBoxContainer {...(dataTestid && { 'data-testid': dataTestid })}>{children}</StyledErrorBoxContainer>
    )
}
